import { Component, OnInit } from '@angular/core';
import { Student } from 'src/app/shared/student.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { ProductService } from 'src/app/shared/product.service';
import { Product } from 'src/app/shared/product.model';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html'
})
export class ProductListComponent implements OnInit {

  deleteMessage: string;
  productList: Product[];
  constructor(private service: ProductService, private fireStore: AngularFirestore) { }

  ngOnInit() {
    this.service.getAllProducts().subscribe(response => {
      this.productList = response.map(document => {
        return {
          id: document.payload.doc.id,
          ...document.payload.doc.data() as {}    // Attention - Require typescript version >3 to work!!
        } as Student;
      })

      // Sorting the student-list in ascending order.
      console.log(this.productList);
      this.productList = this.productList.sort((obj1, obj2) => (obj1 as any).rollNo - (obj2 as any).rollNo);
      console.log(this.productList);
    });
  }

  onEdit(product: Product) {
    this.service.formData = Object.assign({}, product);
  }

  onDelete(product: Product) {
    this.fireStore.doc('products/' + product.id).delete();
    this.deleteMessage = 'successfully deleted!';
  }
}
